// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"bde8e4d0","502":"dec4c112","1637":"bde8e4d0","9297":"bde8e4d0"}[chunkId] + ".chunk.css";
};